// Domain configuration for Digital Signage Management
export const signageDomain = process.env.NODE_ENV === 'production'
  ? 'https://tv.vectorindia.org'
  : 'http://localhost:6011';

export const tvApiDomain = process.env.NODE_ENV === 'production'
  ? 'https://tv.vectorindia.org'
  : 'http://localhost:6011';

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    PROFILE: '/api/auth/profile',
    LOGOUT: '/api/auth/logout',
    VERIFY: '/api/auth/verify',
    USERS: '/api/auth/users'
  },
  DEVICES: {
    LIST: '/api/devices',
    CREATE: '/api/devices',
    UPDATE: (id) => `/api/devices/${id}`,
    DELETE: (id) => `/api/devices/${id}`,
    STATS: '/api/devices/stats/overview',
    HEARTBEAT: (deviceId) => `/api/devices/${deviceId}/heartbeat`
  },
  CONTENT: {
    LIST: '/api/content',
    UPLOAD: '/api/content/upload',
    UPDATE: (id) => `/api/content/${id}`,
    DELETE: (id) => `/api/content/${id}`,
    TYPES: '/api/content/types/list',
    STATS: '/api/content/stats/overview'
  },
  LAYOUTS: {
    LIST: '/api/layouts',
    CREATE: '/api/layouts',
    UPDATE: (id) => `/api/layouts/${id}`,
    DELETE: (id) => `/api/layouts/${id}`,
    DUPLICATE: (id) => `/api/layouts/${id}/duplicate`,
    PREVIEW: (id) => `/api/layouts/${id}/preview`,
    STATS: '/api/layouts/stats/overview'
  },
  PLAYLISTS: {
    LIST: '/api/playlists',
    CREATE: '/api/playlists',
    UPDATE: (id) => `/api/playlists/${id}`,
    DELETE: (id) => `/api/playlists/${id}`,
    STATS: '/api/playlists/stats/overview'
  },
  SCHEDULES: {
    LIST: '/api/schedules',
    CREATE: '/api/schedules',
    UPDATE: (id) => `/api/schedules/${id}`,
    DELETE: (id) => `/api/schedules/${id}`,
    STATS: '/api/schedules/stats/overview'
  },
  ANALYTICS: {
    OVERVIEW: '/api/analytics/overview',
    CONTENT: '/api/analytics/content',
    DEVICES: '/api/analytics/devices'
  }
};

// TV API endpoints (public API for devices)
export const TV_API_ENDPOINTS = {
  CONFIG: (deviceId) => `/tv-api/device/${deviceId}/config`,
  CONTENT_FILE: (contentId) => `/tv-api/content/${contentId}/file`,
  THUMBNAIL: (contentId) => `/tv-api/content/${contentId}/thumbnail`,
  STATUS_UPDATE: (deviceId) => `/tv-api/device/${deviceId}/status`,
  ANALYTICS: (deviceId) => `/tv-api/device/${deviceId}/analytics`,
  EMERGENCY: (deviceId) => `/tv-api/device/${deviceId}/emergency`,
  TIME: '/tv-api/time'
};

export default signageDomain;